<div class="app-add-break container">
  <div class="centered full-width">
    <div class="clickable dflex-center" (click)="onHandleBack()">
      <mat-icon
        aria-hidden="false"
        aria-label="Example home icon"
        fontIcon="arrow_back"
      ></mat-icon>
      Back
    </div>
    <div class="section-wrapper">
      <mat-card appearance="outlined" class="left-section">
        <h3 class="title">Add a break</h3>
        <div>
          <label for="break_start"> Break start</label>
          <mat-form-field
            appearance="fill"
            class="full-width outlined break-time"
            [ngClass]="{
              active: activeField === 'break_start'
            }"
            >
            <input
              matInput
              [value]="break_start.time"
              readonly
              (click)="onHandleSelectActiveField('break_start')"
              />
            <button mat-button (click)="onHandleChangeMeridian('break_start')">
              {{ break_start.meridian }}
            </button>
          </mat-form-field>
          @if (!break_start.isValid) {
            <mat-hint>
              <mat-error>Please enter a valid time (01-12:00-59)</mat-error>
            </mat-hint>
          }
        </div>

        <div>
          <label for="break_end"> Break end</label>
          <mat-form-field
            appearance="fill"
            class="full-width outlined break-time"
            [ngClass]="{
              active: activeField === 'break_end'
            }"
            >
            <input
              matInput
              [value]="break_end.time"
              readonly
              (click)="onHandleSelectActiveField('break_end')"
              />
            <button mat-button (click)="onHandleChangeMeridian('break_end')">
              {{ break_end.meridian }}
            </button>
          </mat-form-field>
          @if (!break_end.isValid) {
            <mat-hint>
              <mat-error>Please enter a valid time (01-12:00-59)</mat-error>
            </mat-hint>
          }
        </div>
      </mat-card>
      <div class="right-section">
        <app-numeric-keypad
          (eventOnKeyPress)="onHandleKeyPress($event)"
          (eventOnclear)="onHandleClear()"
          (eventOnOk)="onHandleOk()"
          [isLoading]="isLoading"
        ></app-numeric-keypad>
      </div>
    </div>
  </div>
</div>
